export const EXPIRING_DOCUMENTS_FETCH_BEGIN = 'syftacp/EXPIRING_DOCUMENTS_FETCH_BEGIN'
export const EXPIRING_DOCUMENTS_FETCH_FAILED = 'syftacp/EXPIRING_DOCUMENTS_FETCH_FAILED'
export const EXPIRING_DOCUMENTS_FETCH_SUCCEEDED = 'syftacp/EXPIRING_DOCUMENTS_FETCH_SUCCEEDED'
export const EXPIRING_DOCUMENTS_RESOLVE_BEGIN = 'syftacp/EXPIRING_DOCUMENTS_RESOLVE_BEGIN'
export const EXPIRING_DOCUMENTS_RESOLVE_FAILED = 'syftacp/EXPIRING_DOCUMENTS_RESOLVE_FAILED'
export const EXPIRING_DOCUMENTS_RESOLVE_SUCCEEDED = 'syftacp/EXPIRING_DOCUMENTS_RESOLVE_SUCCEEDED'
